import React, {Component} from 'react'
import { NavLink } from 'react-router-dom'

import { withUiContext } from "../../UiContext";
import * as routes from "../../const/routes";

//
import CircleDecor0 from '../../components/Svg/circle-decor-0';
import CircleDecor8 from '../../components/Svg/circle-decor-8';
import CircleDecor9 from '../../components/Svg/circle-decor-9';
import CircleDecor10 from '../../components/Svg/circle-decor-10';
// import PointerLine from '../../components/Svg/pointer-line';
// import PointerDecor from '../../components/Svg/pointer-decor';
import RadialGlow from '../../components/Svg/radial-glow';
import CircleDecor11 from '../../components/Svg/circle-decor-11';
import WaveDecor from '../../components/Svg/wave-decor';
import Languages from '../../const/languages';

class Intro extends Component {

    render() {
        return (
            <div className="hud-preloader">
                <div className="hud-preloader__wrapper">
                    <div className="hud-preloader__circles">
                        <CircleDecor0/>
                        <CircleDecor8/>
                        <CircleDecor9/>
                        <CircleDecor10/>
                    </div>

                    <div className="hud-preloader__logo">
                        {/*{% include "html/icons/logo.svg" %}*/}
                        <NavLink
                            to={routes.HOME}
                            style={{
                                textDecoration: 'none',
                                color: 'white',
                                fontSize: '4rem',
                                fontWeight: 'bold',
                                opacity: 0.95,
                            }}
                        >
                            {Languages.start}
                        </NavLink>
                    </div>

                    { false && (
                        <div className="hud-preloader__pointer">
                            {/*<PointerLine/>*/}
                            {/*<PointerDecor/>*/}

                            <div className="hud-preloader__pointer-text">
                                <div className="hud-preloader__pointer-text__label">ЗАГРУЗКА............</div>
                                <div className="hud-preloader__pointer-text__value">55%</div>
                            </div>
                        </div>
                    )}

                    <div className="hud-preloader__glow">
                        <RadialGlow/>
                    </div>

                    <div className="hud-preloader__decor-top">
                        <CircleDecor11/>
                    </div>

                    <div className="hud-preloader__decor-bottom">
                        <CircleDecor11/>
                    </div>
                </div>

                <div className="hud-preloader__decor-wave">
                    <WaveDecor style={{ opacity: .8 }}/>
                </div>
            </div>
        )
    }
}

export default withUiContext(Intro)
